
export const MuiTreeView = {
    styleOverrides: {
        root: {
            "& > li > div > div > label > span:last-of-type": {
                color: "inherit",
                fontWeight: "inherit"
            },
            "& > li > div > div > label": {  // [GM]: first node label have primary color
                fontWeight: 500
            },
            "& > li > ul > div > div > li[aria-expanded] > div > div > label": { // [GM]: node with childrens
                fontWeight: 500
            }
        }
    }
}
